<template>
  <div>
    <h4 :class="titleClass" v-if="title">
      {{ title }}
    </h4>
    <b-skeleton-wrapper :loading="loading>0">
      <template #loading>
        <div class="d-flex flex-wrap">
          <b-skeleton
              v-for="n in loading"
              :key="n"
              class="m-2 img-thumbnail"
              :width="imgWidth"
              :height="imgHeight"/>
        </div>
      </template>
      <template v-for="(p) in list">
        <router-link
            v-if="p && p.id"
            :key="p.id"
            :to="{ name: 'ProduitVue', params: { id: p.id }}"
        >
          <slot name="img" :produit="p">
            <img
                class="m-2 img-thumbnail placeholder"
                :src="p.image ? `https://www.luqei.com/images/cours/${p.image}.jpg` : 'https://www.luqei.com/images/cours/place_holder.jpg'"
                :width="imgWidth"
                :height="imgHeight"
                alt="">
          </slot>
        </router-link>
      </template>
    </b-skeleton-wrapper>

  </div>
</template>

<script>

export default {
  name : "ExerciceBand",
  props: {
    title     : {type: String},
    titleClass: {type: String},
    elemClass : {type: String},
    imgWidth  : {type: String, default: "150px"},
    imgHeight : {type: String, default: "207.15px"},
    list      : {
      type: Array, default() {
        return []
      }
    },
    loading   : {type: Number, default: 0}
  },
}
</script>

<style scoped>

</style>